
(function () {
  const checkbox = document.querySelector("#age_confirm_cart_page");
  if (!checkbox) return;

  function getBtns() {
    return document.querySelectorAll(".sezzle-checkout-button.sezzle-button-light");
  }

  function updateVisibility() {
    const btns = getBtns();
    if (!btns.length) return;
    btns.forEach(function (btn) {
      btn.style.setProperty("display", checkbox.checked ? "block" : "none", "important");
    });
  }

  // Watch for Sezzle dynamically injecting/modifying the button
  new MutationObserver(function () {
    updateVisibility();
  }).observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ["style", "class"]
  });

  // setInterval as extra enforcement against Sezzle overriding styles
  setInterval(updateVisibility, 300);

  // On checkbox change
  checkbox.addEventListener("change", updateVisibility);

  // Run on load
  updateVisibility();
})();
$(document).ready(function () {
  $(".banners_list").slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true
  });
  $(".review-lists").slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false
  });
  $(".product-slider").slick({
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 3
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 2
        }
      }
    ]
  });
  
  $('.marquee-left').marquee({
      direction: 'left',
      duration: 30000,
      delayBeforeStart: 0,
      duplicated: true,
      gap: 0,
      startVisible: true
  });

});


// tabbed content
// http://www.entheosweb.com/tutorials/css/tabs.asp
$(".tab-container .tab_content").hide();
// $(".tab-container .tab_content:first").show();
$('.tab-container').each(function(k,v){
  $(v).find('.tab_content:first').show();
});

/* if in tab mode */
$("ul.tabs li").click(function() {
  var parent = $(this).parents('.tab-container');

  $(parent).find(".tab_content").hide();
  var activeTab = $(this).attr("rel");
  $(parent).find("#"+activeTab).fadeIn();

  $(parent).find("ul.tabs li").removeClass("active");
  $(this).addClass("active");

  $(parent).find(".tab_drawer_heading").removeClass("d_active");
  $(parent).find(".tab_drawer_heading[rel^='"+activeTab+"']").addClass("d_active");

});
/* if in drawer mode */
$(".tab_drawer_heading").click(function() {
  var parent = $(this).parents('.tab-container');

  $(parent).find(".tab_content").hide();
  var d_activeTab = $(this).attr("rel");
  $(parent).find("#"+d_activeTab).fadeIn();

  $(parent).find(".tab_drawer_heading").removeClass("d_active");
  $(this).addClass("d_active");

  $(parent).find("ul.tabs li").removeClass("active");
  $(parent).find("ul.tabs li[rel^='"+d_activeTab+"']").addClass("active");
});


/* Extra class "tab_last"
   to add border to right side
   of last tab */
$('ul.tabs li').last().addClass("tab_last");



// popup

$(document).ready(function() {

  $('.sm_open').on('click', function(){
      var modal = $(this).attr('data-modal');
      var modaloverlaycolor = $(this).attr('data-overlay');
      var modaleffect = $(this).attr('data-effect');
      var modalheader = $(this).attr('data-header');
      var modalheadertype = $(this).attr('data-header-type');
      var modalcontent = $(this).attr('data-content');
      var modaliconside = $(this).attr('data-icons');
      var modalwrappercolor = $(this).attr('data-wrapper-color');
  
      $('#' + modal).addClass(modaloverlaycolor);
      $('#' + modal + ' .sm_content').addClass(modaleffect);
      $('#' + modal + ' .sm_content .sm_header').html(modalheader);
      $('#' + modal + ' .sm_content .sm_header').addClass(modalheadertype);
      $('#' + modal + ' .sm_content .sm_area_all').html(modalcontent);
      $('#' + modal + ' .sm_icon_menu').addClass(modaliconside);
      $('#' + modal + ' .sm_content').addClass(modalwrappercolor);
      $('#' + modal).fadeIn().css("display", "flex");
      setTimeout(function(){
          $('#'+modal + ' .sm_content').addClass('show');
      }, 400);        
  });
  
  $('.sm_close').on('click', function(){
      var $modal = $(this).parents('.slim_modal');
      closeModal($modal);  
  });
  
  $('.slim_modal').on('click', function(e) {
    if (e.target !== this)
      return;
      var $modal = $(this);
      closeModal($modal);
  });
  
  function closeModal($modal) {
      $modal.find('.sm_content').removeClass('show');
      setTimeout(function(){
          $modal.removeClass('red green tan none');
          $modal.find('.sm_content').removeClass('red green tan');
          $modal.find('.sm_icon_menu').removeClass('is_right is_left');
          $modal.find('.sm_header').removeClass('detached');
          $modal.fadeOut();
      }, 400);
  }
});


// customise cart/ cart drawer/ mini cart notification checkout button toggle with age verification
// (function () {
//   "use strict";
//   // ─── CONFIG ──────────────────────────────────────────────────────────────────
//   const SELECTORS = {
//     cart_page:         '.cart-order .button[name="checkout"]',
//     cart_drawer:       '.cart_drawer_checkout_btn .button[name="checkout"]',
//     cart_notification: '.button[name="checkout"]', // scoped to closest drawer
//   };

//   // All drawer tags that are injected dynamically after page load
//   const DYNAMIC_DRAWERS = [
//     "cart-notification-drawer",
//     "quick-buy-drawer",
//   ];

//   // Both drawer types use cart_notification context — scope button lookup to
//   // whichever drawer is the closest ancestor of the checkbox
//   const SCOPED_DRAWER_TAGS = DYNAMIC_DRAWERS.join(", ");

//   const CHECKBOX_SELECTOR = '.age_verification input[type="checkbox"]';
//   const INITIALIZED_FLAG  = "__ageVerificationBound";
//   const OBSERVER_FLAG     = "__ageVerificationObserver";

//   // ─── CORE ─────────────────────────────────────────────────────────────────────
//   function bindCheckbox(checkbox) {
//     if (!checkbox || checkbox[INITIALIZED_FLAG]) return;

//     const from        = checkbox.dataset.isfrom;
//     const btnSelector = SELECTORS[from];
//     if (!btnSelector) return;

//     let checkoutBtn;

//     if (from === "cart_notification") {
//       // Works for BOTH cart-notification-drawer AND quick-buy-drawer
//       // closest() walks up and finds whichever drawer wraps this checkbox
//       const drawer = checkbox.closest(SCOPED_DRAWER_TAGS);
//       checkoutBtn  = drawer ? drawer.querySelector(btnSelector) : null;
//     } else {
//       checkoutBtn = document.querySelector(btnSelector);
//     }

//     if (!checkoutBtn) return;

//     checkoutBtn.disabled = !checkbox.checked;
//     checkbox.addEventListener("change", function () {
//       checkoutBtn.disabled = !this.checked;
//     });
//     checkbox[INITIALIZED_FLAG] = true;
//   }

//   function initAll() {
//     document.querySelectorAll(CHECKBOX_SELECTOR).forEach(bindCheckbox);
//   }

//   // ─── CONTAINER OBSERVER ──────────────────────────────────────────────────────
//   function observeContainer(container) {
//     if (!container || container[OBSERVER_FLAG]) return;

//     new MutationObserver(function (mutations) {
//       const hasAddedNodes = mutations.some(
//         (m) => m.type === "childList" && m.addedNodes.length > 0
//       );
//       if (hasAddedNodes) initAll();
//     }).observe(container, { childList: true, subtree: true });

//     container[OBSERVER_FLAG] = true;
//   }

//   function observeKnown() {
//     observeContainer(document.querySelector("#cart-drawer"));
//     DYNAMIC_DRAWERS.forEach(function (tag) {
//       document.querySelectorAll(tag).forEach(observeContainer);
//     });
//   }

//   // ─── BODY OBSERVER ───────────────────────────────────────────────────────────
//   // Detects cart-notification-drawer AND quick-buy-drawer injected after load

//   new MutationObserver(function (mutations) {
//     mutations.forEach(function (m) {
//       m.addedNodes.forEach(function (node) {
//         if (node.nodeType !== 1) return;

//         const isDynamicDrawer = DYNAMIC_DRAWERS.some(
//           (tag) => node.matches && node.matches(tag)
//         );

//         if (isDynamicDrawer) {
//           observeContainer(node);
//           initAll();
//         } else if (node.querySelectorAll) {
//           let found = false;
//           DYNAMIC_DRAWERS.forEach(function (tag) {
//             node.querySelectorAll(tag).forEach(function (drawer) {
//               observeContainer(drawer);
//               found = true;
//             });
//           });
//           if (found) initAll();
//         }
//       });
//     });
//   }).observe(document.body, { childList: true, subtree: true });

//   // ─── CART ICON CLICK ─────────────────────────────────────────────────────────

//   document.addEventListener(
//     "click",
//     function (e) {
//       if (e.target.closest(".header .cart-box, [href*='/cart'], [data-cart-toggle]")) {
//         setTimeout(initAll, 350);
//       }
//     },
//     { passive: true }
//   );

//   // ─── FORM SUBMIT (product page + quick buy) ───────────────────────────────────

//   document.addEventListener(
//     "submit",
//     function (e) {
//       const form = e.target;
//       if (
//         form.matches(".shopify-product-form") ||
//         form.querySelector('button[type="submit"]')
//       ) {
//         setTimeout(function () {
//           observeKnown();
//           initAll();
//         }, 600);
//       }
//     },
//     { passive: true }
//   );

//   // ─── SHOPIFY AJAX / CUSTOM EVENTS ────────────────────────────────────────────

//   [
//     "cart:updated",
//     "cart:refresh",
//     "cart:open",
//     "drawer:open",
//     "ajaxCart:afterSetQuantity",
//     "theme:cart:open",
//   ].forEach(function (eventName) {
//     document.addEventListener(eventName, function () {
//       setTimeout(function () {
//         observeKnown();
//         initAll();
//       }, 200);
//     });
//   });

//   // ─── BOOT ────────────────────────────────────────────────────────────────────

//   function boot() {
//     initAll();
//     observeKnown();
//   }

//   if (document.readyState === "loading") {
//     document.addEventListener("DOMContentLoaded", boot);
//   } else {
//     boot();
//   }

// })();

(function () {
  "use strict";
  // ─── CONFIG ──────────────────────────────────────────────────────────────────
  const SELECTORS = {
    cart_page:         '.cart-order .button[name="checkout"]',
    cart_drawer:       '.cart_drawer_checkout_btn .button[name="checkout"]',
    cart_notification: '.button[name="checkout"]', // scoped to closest drawer
    cart_ext_checkout: '.sezzle-checkout-button.sezzle-button-light'
  };

  // All drawer tags that are injected dynamically after page load
  const DYNAMIC_DRAWERS = [
    "cart-notification-drawer",
    "quick-buy-drawer",
  ];

  const SCOPED_DRAWER_TAGS = DYNAMIC_DRAWERS.join(", ");

  const CHECKBOX_SELECTOR = '.age_verification input[type="checkbox"]';
  const INITIALIZED_FLAG  = "__ageVerificationBound";
  const OBSERVER_FLAG     = "__ageVerificationObserver";

  // ─── SEZZLE SYNC ─────────────────────────────────────────────────────────────
  // Called any time a sezzle button appears in the DOM — applies the current
  // checkbox state immediately so it is never visible before consent is given.

  function syncSezzleBtn(sezzleBtn) {
    if (!sezzleBtn) return;

    // Find the nearest checkbox that governs this button's context
    const drawer   = sezzleBtn.closest(SCOPED_DRAWER_TAGS);
    let   checkbox = null;

    if (drawer) {
      checkbox = drawer.querySelector(CHECKBOX_SELECTOR);
    }

    // Fall back to page-level checkbox (cart page / cart drawer)
    if (!checkbox) {
      checkbox = document.querySelector(CHECKBOX_SELECTOR);
    }

    const checked = checkbox ? checkbox.checked : false;
    sezzleBtn.style.display = checked ? "" : "none";
  }

  function syncAllSezzleBtns() {
    document.querySelectorAll(SELECTORS.cart_ext_checkout).forEach(syncSezzleBtn);
  }

  // ─── CORE ─────────────────────────────────────────────────────────────────────
  function bindCheckbox(checkbox) {
    if (!checkbox || checkbox[INITIALIZED_FLAG]) return;

    const from        = checkbox.dataset.isfrom;
    const btnSelector = SELECTORS[from];
    if (!btnSelector) return;

    let checkoutBtn;

    if (from === "cart_notification") {
      const drawer = checkbox.closest(SCOPED_DRAWER_TAGS);
      checkoutBtn  = drawer ? drawer.querySelector(btnSelector) : null;
    } else {
      checkoutBtn = document.querySelector(btnSelector);
    }

    if (!checkoutBtn) return;

    // ── initial state ──────────────────────────────────────────────────────────
    checkoutBtn.disabled = !checkbox.checked;
    syncAllSezzleBtns(); // apply to any sezzle btns already in DOM

    // ── on change ─────────────────────────────────────────────────────────────
    checkbox.addEventListener("change", function () {
      checkoutBtn.disabled = !this.checked;
      syncAllSezzleBtns(); // re-sync all sezzle btns on every toggle
    });

    checkbox[INITIALIZED_FLAG] = true;
  }

  function initAll() {
    document.querySelectorAll(CHECKBOX_SELECTOR).forEach(bindCheckbox);
    syncAllSezzleBtns(); // catch sezzle btns that arrived before checkbox bound
  }

  // ─── CONTAINER OBSERVER ──────────────────────────────────────────────────────
  function observeContainer(container) {
    if (!container || container[OBSERVER_FLAG]) return;

    new MutationObserver(function (mutations) {
      let hasSezzle    = false;
      let hasOtherNode = false;

      mutations.forEach(function (m) {
        if (m.type !== "childList") return;
        m.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          // Check if the node itself is a sezzle button or contains one
          if (node.matches && node.matches(SELECTORS.cart_ext_checkout)) {
            syncSezzleBtn(node);
            hasSezzle = true;
          } else if (node.querySelectorAll) {
            node.querySelectorAll(SELECTORS.cart_ext_checkout).forEach(function (btn) {
              syncSezzleBtn(btn);
              hasSezzle = true;
            });
          }
          if (!hasSezzle) hasOtherNode = true;
        });
      });

      // Re-run full init for non-sezzle additions (new checkboxes etc.)
      if (hasOtherNode) initAll();
    }).observe(container, { childList: true, subtree: true });

    container[OBSERVER_FLAG] = true;
  }

  function observeKnown() {
    observeContainer(document.querySelector("#cart-drawer"));
    DYNAMIC_DRAWERS.forEach(function (tag) {
      document.querySelectorAll(tag).forEach(observeContainer);
    });
  }

  // ─── BODY OBSERVER ───────────────────────────────────────────────────────────
  new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;

        const isDynamicDrawer = DYNAMIC_DRAWERS.some(
          (tag) => node.matches && node.matches(tag)
        );

        if (isDynamicDrawer) {
          observeContainer(node);
          initAll();
        } else if (node.querySelectorAll) {
          let found = false;
          DYNAMIC_DRAWERS.forEach(function (tag) {
            node.querySelectorAll(tag).forEach(function (drawer) {
              observeContainer(drawer);
              found = true;
            });
          });
          if (found) initAll();

          // Also catch sezzle buttons injected directly into body-level nodes
          node.querySelectorAll(SELECTORS.cart_ext_checkout).forEach(syncSezzleBtn);
          if (node.matches && node.matches(SELECTORS.cart_ext_checkout)) {
            syncSezzleBtn(node);
          }
        }
      });
    });
  }).observe(document.body, { childList: true, subtree: true });

  // ─── CART ICON CLICK ─────────────────────────────────────────────────────────
  document.addEventListener(
    "click",
    function (e) {
      if (e.target.closest(".header .cart-box, [href*='/cart'], [data-cart-toggle]")) {
        setTimeout(initAll, 350);
      }
    },
    { passive: true }
  );

  // ─── FORM SUBMIT (product page + quick buy) ───────────────────────────────────
  document.addEventListener(
    "submit",
    function (e) {
      const form = e.target;
      if (
        form.matches(".shopify-product-form") ||
        form.querySelector('button[type="submit"]')
      ) {
        setTimeout(function () {
          observeKnown();
          initAll();
        }, 600);
      }
    },
    { passive: true }
  );

  // ─── SHOPIFY AJAX / CUSTOM EVENTS ────────────────────────────────────────────
  [
    "cart:updated",
    "cart:refresh",
    "cart:open",
    "drawer:open",
    "ajaxCart:afterSetQuantity",
    "theme:cart:open",
  ].forEach(function (eventName) {
    document.addEventListener(eventName, function () {
      setTimeout(function () {
        observeKnown();
        initAll();
      }, 200);
    });
  });

  // ─── BOOT ────────────────────────────────────────────────────────────────────
  function boot() {
    initAll();
    observeKnown();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

})();

// age verification popup before visiting website
document.addEventListener("DOMContentLoaded", function () {
  // Days 1–31
  const daySelect = document.querySelector(".dobd");
  for (let i = 1; i <= 31; i++) {
    let day = i.toString().padStart(2, '0');
    let option = new Option(day, day);
    daySelect.add(option);
  }

  // Years 1940 to current year
  const yearSelect = document.querySelector(".doby");
  const currentYear = new Date().getFullYear();
  const startYear = 1940;

  for (let y = currentYear; y >= startYear; y--) {
    let option = new Option(y, y);
    yearSelect.add(option);
  }

  // change event
  document.querySelectorAll(".verify_dob .dobm, .verify_dob .dobd, .verify_dob .doby")
  .forEach(select => {
    select.addEventListener("change", validateDOB);
  });

  function validateDOB() {
    const day   = document.querySelector(".verify_dob .dobd").value;
    const month = document.querySelector(".verify_dob .dobm").value;
    const year  = document.querySelector(".verify_dob .doby").value;
    const messageBox = document.querySelector(".validation_msg");
    const checkBtn   = document.querySelector(".check_age");

    let errors = [];
    let validAge = false;

    if (!month) errors.push("Please select month");
    if (!day)   errors.push("Please select day");
    if (!year)  errors.push("Please select year");

    if (month && day && year) {
      const today = new Date();
      const birthDate = new Date(year, month - 1, day);
      let age = today.getFullYear() - birthDate.getFullYear();
      const m = today.getMonth() - birthDate.getMonth();

      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }

      if (age < 18) {
        errors.push("Your age must be at least 18 years.");
      } else {
        validAge = true;
      }
    }

    // render errors
    messageBox.innerHTML = "";
    errors.forEach(err => {
      const span = document.createElement("span");
      span.className = "errors";
      span.textContent = err;
      messageBox.appendChild(span);
    });

    // toggle button
    if (validAge && errors.length === 0) {
      checkBtn.removeAttribute("disabled");
    } else {
      checkBtn.setAttribute("disabled", true);
    }
  }

  $(document).on('click', '.check_age', function() {
    var getMonth = $('.dobm').val();
    var getDay   = $('.dobd').val();
    var getYear  = $('.doby').val();
    var messageBox = $('.validation_msg');

    $('.checkoutInput').removeClass('error');
    messageBox.html('');
    var errors = [];
    if(!getMonth){
      errors.push("Please select month");
      $('.dobm').addClass('error');
    }
    if(!getDay){
      errors.push("Please select day");
      $('.dobd').addClass('error');
    }
    if(!getYear){
      errors.push("Please select year");
      $('.doby').addClass('error');
    }

    // show validation messages
    if(errors.length > 0){
      errors.forEach(function(err){
        messageBox.append('<span class="errors">'+err+'</span>');
      });
      return false;
    }

    // calculate age
    var dob = new Date(getYear, getMonth - 1, getDay);
    var today = new Date();
    var age = Math.floor((today - dob) / (365.25 * 24 * 60 * 60 * 1000));
    var minAge = parseInt($('.requiredAge').val());

    if(age < minAge){
      messageBox.append('<span class="errors">It appears you are not of legal age to access this website.</span>');
      return false;
    } else {
      // success
      setCookie("user_age_data", window.btoa(age), 1);
      var country  = $('.scountry').val();
      var province = $('.sstate_ca').val();

      var redirects = {
        'AB': 'https://www.gascityvapes.com/?region_override=0OEzs1DwGq',
        'BC': 'https://www.gascityvapes.com/?region_override=D4GyE2ixL4',
        'MB': 'https://www.gascityvapes.com/?region_override=1f10Bp8MsN',
        'NL': 'https://www.gascityvapes.com/?region_override=njDSvom0Lv',
        'NS': 'https://www.gascityvapes.com/?region_override=Isbs1yMKGU',
        'ON': 'https://www.gascityvapes.com/?region_override=Ou9PSI82sf',
        'SK': 'https://www.gascityvapes.com/?region_override=wd7c6KDdnF'
      };

      if (country === 'CA' && redirects[province]) {
        window.location.href = redirects[province];
      } else {
        $('#age_verfication_modal').hide();
        $('html').removeClass('age-gate-pending');
      }
    }

  });

});
